<mat-card class="row ml-3" [formGroup]="params" #documentEditForm="ngForm">
  <mat-card-title>	
    {{ 'FARM.FILTER_FARMS' | translate }}
  </mat-card-title>
  <mat-form-field class="col-sm-12">
    <mat-label>{{ 'FARM.COUNTRY.COUNTRY' | translate }}</mat-label>
    <mat-select [compareWith]="compareFunction"  formControlName="country">
      <mat-option ngDefaultControl *ngFor="let country of getCountries()"  [(value)]='country.cod'>{{ 'FARM.COUNTRY.' + country.country | uppercase | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="params.controls['country'].value=='es'" >
    <mat-form-field class="col-sm-12">
      <mat-label>{{ 'FARM.PROVINCE' | translate }}</mat-label>
      <mat-select  formControlName="province" (selectionChange)="onChangeProvince($event)" required>
        <mat-option *ngFor="let province of provinces"  [value]='province.idProvince'>{{province.provinceName}} </mat-option>
      </mat-select>
    </mat-form-field>
      <mat-form-field class="col-sm-12">
        <mat-label>{{ 'FARM.TOWN_HALL' | translate }}</mat-label>
        <mat-select (selectionChange)="onSelectedTownHall($event.value)"  required>
          <mat-option *ngFor="let th of townHalls"  [value]='th'>{{th.townHallName}}  </mat-option>
        </mat-select>
    </mat-form-field>
  </div>    
  <div *ngIf="params.controls['country'].value=='pt'" >
    <mat-form-field class="col-sm-12">
      <mat-label>{{ 'FARM.DISTRICT' | translate }}</mat-label>
      <mat-select  formControlName="district" (selectionChange)="onChangeDistrict($event)">
          <mat-option *ngFor="let district of districts"  [value]='district.idDistrict'>{{district.districtName}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col-sm-12">
      <mat-label>{{ 'FARM.MUNICIPALITY' | translate }}</mat-label>
      <mat-select (selectionChange)="onSelectedMunicipality($event.value)"  required>
        <mat-option *ngFor="let th of municipalities"  [value]='th'>{{th.municipalityName}}  </mat-option>
      </mat-select>
    </mat-form-field>
  </div> 
    <div class="col-sm-12">
      <span >{{ 'FARM.DESITE_TO.DESITE_TO' | translate }}:</span>
      <div class="col-sm-12"  *ngFor="let exp of data_exploitation">
        <mat-checkbox  [value]="exp" (change)="onChange($event,'exploitations')">{{'FARM.DESITE_TO.TYPE.' + exp.type | uppercase | translate }}</mat-checkbox>
      </div>
    </div>
    <div class="col-sm-12">
      <span >{{ 'FARM.OBJECTIVES_TO.OBJECTIVES_TO' | translate }}:</span>
      <div class="col-sm-12"  *ngFor="let obj of data_objectives">
        <mat-checkbox   [value]="obj" (change)="onChange($event, 'objectives')">{{ 'FARM.OBJECTIVES_TO.TYPE.' + obj.type | uppercase | translate }}</mat-checkbox>
      </div>
    </div>
    <div class="col-sm-12">
      <mat-form-field>
        <mat-label style="display: block; margin-bottom: .4rem;">{{ 'FARM.AREA' | translate }} min(ha)</mat-label>
        <input matInput type=number  placeholder="{{'FARM.AREA' | translate}}" min="0" formControlName="areaMin" >
      </mat-form-field>
    </div>
    <div class="col-sm-12">
      <mat-form-field>
        <mat-label style="display: block; margin-bottom: .4rem;">{{ 'FARM.AREA' | translate }} max(ha)</mat-label>
        <input matInput type=number placeholder="{{'FARM.AREA' | translate}}" min="0" max="1000" formControlName="areaMax" (focusout)="onEnterArea($event)">
      </mat-form-field>
    </div>
    <div class="col-sm-12">
      <span>{{ 'FARM.ACCESS_ROAD.ACCESS_ROAD' | translate }}</span>
      <mat-radio-group formControlName="accessRoad" required class="row">
        <mat-radio-button class="col-12 col-sm-12 col-md-12" [checked]="true"  value=null>{{ 'FARM.ACCESS_ROAD.INDIFFERENT' | translate }}</mat-radio-button>
        <mat-radio-button class="col-12 col-sm-12 col-md-12" value="true">{{ 'FARM.ACCESS_ROAD.YES' | translate }}</mat-radio-button>
        <mat-radio-button class="col-12 col-sm-12 col-md-12" value="false">{{ 'FARM.ACCESS_ROAD.NO' | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>
  </mat-card> 